// extracted by mini-css-extract-plugin
export default {"container":"friendlyCaptcha-module__container--iQh1T"};